<template>
  <div class="template-container" >
    <el-tabs class="mt-3" v-model="type" @tab-click="handleTabClick" type="card">
      <el-tab-pane  :label="$t('resourceManage.resource')" name="resource"></el-tab-pane>
      <el-tab-pane  :label="$t('resourceManage.acceleration')" name="acceleration"></el-tab-pane>
      <el-tab-pane  :label="$t('resourceManage.traffic')" name="traffic"></el-tab-pane>
      <el-tab-pane  :label="$t('resourceManage.order')" name="order"></el-tab-pane>
    </el-tabs>
    <div class="mb-2 mt-2 pt-3">
      <template>
        <el-form inline ref="form" :model="from" label-width="100px">
          <el-form-item :label="$t('userList.userName')" class="mb-0">
            <el-input clearable="" size="small" v-model="from.username"></el-input>
          </el-form-item>
          <el-form-item :label="$t('adminList.createTime')"  class="mb-0">
            <el-date-picker
                size="small"
                v-model="from.time"
                type="daterange"
                align="right"
                unlink-panels
                value-format="yyyy-MM-dd"
                :range-separator="$t('system.to')"
                :start-placeholder="$t('system.startTime')"
                :end-placeholder="$t('system.endTime')"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item class="mb-0">
            <el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
            <el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
          </el-form-item>
        </el-form>
      </template>
    </div>
    <el-table
        :data="orderList"
        border
        v-loading="loading"
        style="width: 100%">
      <el-table-column prop="id" :label="$t('cdnOrderList.id')" width="80" align="center"></el-table-column>
      <el-table-column prop="user_id" :label="$t('cdnOrderList.uid')" width="80" align="center"></el-table-column>
      <el-table-column prop="user_name" :label="$t('userList.userName')" min-width="100"></el-table-column>
      <el-table-column prop="price" :label="$t('cdnOrderList.price')" min-width="100"></el-table-column>
      <el-table-column prop="size" :label="$t('trafficList.size')" min-width="100"></el-table-column>
      <el-table-column prop="quantity" :label="$t('trafficList.quantity')" min-width="80"></el-table-column>
      <el-table-column prop="duration" :label="$t('cdnOrderList.duration')" min-width="80"></el-table-column>
      <el-table-column
          prop="renewal"
          :label="$t('cdnOrderList.renewal')"
          min-width="80"
          :formatter="formatRenewal">
      </el-table-column>
      <el-table-column prop="resource_name" :label="$t('resourceList.name')" min-width="100"></el-table-column>
      <el-table-column prop="acceleration_name" :label="$t('accelerationList.name')" min-width="100"></el-table-column>
      <el-table-column prop="create_time" :label="$t('cdnOrderList.createTime')" min-width="130"></el-table-column>
      <el-table-column fixed="right" :label="$t('cdnOrderList.operation')" width="100" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" class="delete-btn" @click="handleDeleteResource(scope.row)">{{ $t('resourceList.delete') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[5,10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total">
      </el-pagination>
    </div>

  </div>
</template>


<script>
  export default {
    name: 'orderManege',
    data(){
      return{

        type : "order",
        orderList : [],
        loading : false,
        pagination:{
          currentPage: 1,
          pageSize: 5,
          total: 0
        },
        searchQuery:'',
        from : {
          username : '',
          time : []
        }
      }
    },
    created() {
      this.getOrderList()
    },
    methods:{
      // 处理标签页点击
      handleTabClick(tab) {
        const routeMap = {
          resource: '/cdn/resourceManage',
          acceleration: '/cdn/accelerationManage',
          traffic:'/cdn/trafficManage',
          order:'/cdn/orderManage'
        }

        if (routeMap[tab.name] && this.$route.path !== routeMap[tab.name]) {
          this.$router.push(routeMap[tab.name])
        }
      },
      getOrderList(){
        this.loading = true; // 开始加载，显示 loading
        const params = {
          page: this.pagination.currentPage,
          limit: this.pagination.pageSize,
          search: this.from
        }
        this.axios.post('/admin/data/CdnOrderList',params,{
          token : true
        }).then(res => {
          console.log('getOrderList')
          console.log(res.data)
          const {status,data,msg} = res
          if(status === 200 && data && data.code === 1){
            this.orderList = data.data.list.list || []
            this.pagination.total = data.data.list.total || 0
          }else {
            this.$message.error(msg || this.$t('orderList.getOrderError'))
            this.orderList = []
          }

        }).catch(error => {
          this.$message.error(error || this.$t('orderList.getOrderError'))
          this.orderList = []
        }).finally(() => {
          this.loading = false
        })

      },
      //处理每页条数变化
      handleSizeChange(val){
        this.pagination.pageSize = val
        this.pagination.currentPage = 1
        this.getOrderList()
      },
      //处理页码变化
      handleCurrentChange(val){
        this.pagination.currentPage = val
        this.getOrderList()
      },
      // 搜索方法
      searchEvent() {
        this.pagination.currentPage = 1  // 搜索时重置到第一页
        this.getOrderList()
      },
      // 重置搜索条件
      clearSearch() {
        this.from = {
          username: '',
          time: []
        }
        this.searchEvent()  // 重置后重新加载数据
      },
      // 处理删除资源
      handleDeleteResource(row) {
        this.$confirm(this.$t('cdnOrderList.deleteConfirm'), this.$t('system.prompt'), {
          confirmButtonText: this.$t('system.confirm'),
          cancelButtonText: this.$t('system.cancel'),
          type: 'warning'
        }).then(() => {
          this.loading = true; // 开始加载
          this.axios.post('/admin/data/deleteCdnOrder', {
            id: row.id
          }, {
            token: true
          }).then(res => {
            if (res.status === 200 && res.data && res.data.code === 1) {
              this.$message.success(res.data.msg || this.$t('system.deleteSuccess'))
              this.getOrderList()
            } else {
              this.$message.error(res.data.msg || this.$t('resourceList.deleteError'))
            }
          }).catch(error => {
            this.$message.error(error || this.$t('resourceList.deleteError'))
          })
        }).catch(() => {
          this.$message.info(this.$t('cdnOrderList.cancelDelete'))
        }).finally(() => {
          this.loading = false
        })
      },
      formatRenewal(row, column, cellValue) {
        return cellValue === 0 ? '自动续费' : '手动续费';
        // 如果需要国际化，可以使用：
        // return cellValue === 0 ? this.$t('somePath.autoRenewal') : this.$t('somePath.manualRenewal');
      }
    }
  }
</script>

<style scoped>
.pagination-container {
  margin-top: 20px;
  text-align: right;
}
.template-container {
  padding: 20px;
}
.delete-btn {
  color: #F56C6C;
}
</style>

